import { create } from "zustand";

// Session-only and account-scoped: never infer eligibility from client-side
// Castle data, and never show one account's notice to another signed-in user.
export const useEmailReviewStore = create<{ userId: string | null }>(() => ({ userId: null }));

export function recordEmailReviewRestriction(userId: string | undefined, status: number, code: unknown) {
  if (userId && status === 403 && code === "trial_ai_review_required") {
    useEmailReviewStore.setState({ userId });
  }
}

export function clearEmailReviewRestriction(userId: string | undefined) {
  if (userId && useEmailReviewStore.getState().userId === userId) {
    useEmailReviewStore.setState({ userId: null });
  }
}
